// extracted by mini-css-extract-plugin
export var copyable = "_v-1";
export var explainable = "_v-0";
export var negative = "_v-2";
export var positive = "_v-3";